const listaDeMenus = (state) => {
    return state.items;
}

// const listaDeOrdenacao = (state) => {
//     return state.ordenacao;
// }

const loadingMenus = (state) => {
    return state.carregando
}

export {
    listaDeMenus,
    loadingMenus,
    // listaDeOrdenacao
}